<mat-card>
    <h2>{{ name() }}</h2>
    <div class="content">
        <mat-icon class="icon" [svgIcon]="svgIcon()"/>
        @if (value() !== undefined && value() !== null) {
            <div class="value">{{ value() }}</div>
        }
    </div>
</mat-card>
